import { Icon } from '@chakra-ui/react';

export const GlobeIcon = ({ width }: { width: string }) => {
	return (
		<Icon
			w={width}
			h={width}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12H3M12 21C7.02944 21 3 16.9706 3 12M12 21C12 21 16 18 16 12C16 6 12 3 12 3M12 21C12 21 8 18 8 12C8 6 12 3 12 3M3 12C3 7.02944 7.02944 3 12 3"
				stroke="white"
				strokeWidth="1.5"
			/>
		</Icon>
	);
};
